// extracted by css-extract-rspack-plugin
export default {"bloko-slide":"bloko-slide","bloko-slide__container":"bloko-slide__container","bloko-slide__item":"bloko-slide__item"};